<template>
  <div>
    <h2>Welcome to Twitter</h2>
  </div>
</template>


<style lang="sass" scoped>
div
    height: 60vh
    display: flex
    align-items: center
    justify-content: center
</style>